import React from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { formatName } from "helpers/utils"
import { Card, CardBody } from "reactstrap"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import downloadIcon from "../../../assets/images/download.png"

const getHighlightedHTML = (html, query) => {
  if (!query) return html

  const escapedKeyword = query.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
  const regex = new RegExp(`(${escapedKeyword})`, "gi")

  const parser = new DOMParser()
  const doc = parser.parseFromString(html, "text/html")

  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (regex.test(node.textContent)) {
        const spanWrapper = document.createElement("span")
        const replacedHTML = node.textContent.replace(
          regex,
          `<span style="background-color: yellow;">$1</span>`
        )
        spanWrapper.innerHTML = replacedHTML

        node.replaceWith(...spanWrapper.childNodes)
      }
    } else {
      node.childNodes.forEach(walk)
    }
  }

  doc.body.childNodes.forEach(walk)
  return doc.body.innerHTML
}

const AboutIcd = ({ data, query }) => {
  return (
    <>
      {data?.data?.data && (
        <Card>
          <div className="page-search-title">
            <Breadcrumb title={formatName(data.title)} />
          </div>

          <CardBody>
            <div
              style={{
                maxHeight: "auto",
                overflowY: "auto",
              }}
            >
              <div
                style={{ marginTop: "30px" }}
                dangerouslySetInnerHTML={{
                  __html: getHighlightedHTML(data?.data?.data?.value, query),
                }}
              />
            </div>
          </CardBody>
        </Card>
      )}

      {data?.data?.docs?.length > 0 && (
        <Card>
          <div className="page-search-title">
            <Breadcrumb title={"Documents"} />
          </div>
          <CardBody>
            <div className="playlist-wrapper-section mt-5">
              {data?.data?.docs.map((item, index) => (
                <div key={`document_${index}`} className="playlist-card-box ">
                  <div className="align-self-center text-center">
                    <img src={pdfIcon} alt="Download PDF" />
                  </div>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      marginTop: "14px",
                      marginBottom: "14px",
                    }}
                  >
                    {item.title}
                  </p>

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      marginBottom: "14px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                      color: "#09518C",
                    }}
                  >
                    <a
                      href={item.document_url}
                      className="d-flex flex-column play-icon"
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#09518C", fontSize: "16px" }}
                    >
                      Download
                    </a>
                    <img height={"20px"} src={downloadIcon} />
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default AboutIcd
